export const widgetRegister = {
    'widget.home': () => import('./home/HomeWidget'),
    'widget.listings': () => import('./listings/LisingsWidget'),
    'widget.listings.buy': () => import('./listingsBuy/ListingsBuyWidget'),
    'widget.listings.rent': () => import('./listingsRent/ListingsRentWidget'),
    'widget.listings.sell': () => import('./listingsSell/ListingsSellWidget'),
    'widget.agencies': () => import('./agencies/AgenciesWidget'),
    'widget.company': () => import('./company/CompanyWidget'),
    'widget.listing.detail': () => import('./listingDetail/ListingDetailWidget'),
};
